import {
  Button,
  InputAdornment,
  TextField,
  CircularProgress,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { ReactComponent as AlertIcon } from "../Icons/ErrorAlert.svg";
import {
  StyledPrimaryTypography,
  StyledSecondaryTypography,
  StyledErrorTypography,
} from "../Theme";
import { useDispatch, useSelector } from "react-redux";
import {
  login,
  verifyEmail,
  setLoginSliceToNull,
} from "../Redux/Feature/Login/loginSlice";
import { ReactComponent as BackArrow } from "../Icons/BackArrow.svg";
import { showToast } from "../CommonComponents/Toaster";

const SignUp = ({ email, setEmail, setDisplayScreen, setIsForgotPassword }) => {
  const dispatch = useDispatch();
  const { loginStatus, verifyEmailStatus } = useSelector(
    (state) => state.Login
  );
  const [errorText, setErrorText] = useState("");
  const emailRegex =
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const [loadingBtn, setLoadingBtn] = useState(false);

  useEffect(() => {
    if (verifyEmailStatus !== null) {
      setLoadingBtn(false);
      if (verifyEmailStatus.success === true) {
        setIsForgotPassword(false);
        setDisplayScreen("otp");
        dispatch(setLoginSliceToNull());
      } else if (
        (console.log(verifyEmailStatus, "verifyEmailStatus"),
        !verifyEmailStatus.success &&
          verifyEmailStatus.error === "Invalid User")
      ) {
        setErrorText(verifyEmailStatus.error);
      } else if (
        (console.log(verifyEmailStatus, "verifyEmailStatus"),
        !verifyEmailStatus.success &&
          verifyEmailStatus.error === "Already Verified")
      ) {
        setErrorText(verifyEmailStatus.error);
      } else {
        showToast("Something went wrong! Please try again.", "error");
      }
    }
    return () => dispatch(setLoginSliceToNull());
  }, [verifyEmailStatus]);

  const handleEmail = (e) => {
    let { value } = e.target;
    setEmail(value);
    setErrorText("");
  };
  const handleSingUp = () => {
    let isError = validateEmail();
    if (!isError) {
      setLoadingBtn(true);
      dispatch(verifyEmail({ email }));
    }
  };

  const validateEmail = () => {
    let isError = false;
    if (email === "") {
      setErrorText("Error! No input detected.");
      isError = true;
    } else if (emailRegex.test(email) === false) {
      setErrorText("Enter valid email");
      isError = true;
    }
    return isError;
  };
  const handleBack = () => {
    setDisplayScreen("");
    setEmail("");
  };
  return (
    <>
      <BackArrow onClick={handleBack} style={{ cursor: "pointer" }} />
      <StyledPrimaryTypography style={{ marginTop: "15px" }}>
        Sign up{" "}
      </StyledPrimaryTypography>
      <StyledSecondaryTypography>
        The LOBY sign up portal is for authorised condo administrators.
      </StyledSecondaryTypography>
      <TextField
        value={email}
        placeholder="Filled the Email"
        onChange={handleEmail}
        inputProps={{ maxLength: 125 }}
        InputProps={{
          disableUnderline: true,
          endAdornment: (
            <InputAdornment position="end">
              {errorText !== "" && <AlertIcon />}
            </InputAdornment>
          ),
        }}
        sx={{
          mt: 3,
          mb: 2,
          "& .MuiInputBase-root": {
            color: errorText === "" ? "#111927" : "#912018",
          },
          backgroundColor: errorText === "" ? "#F9FAFB" : "#FEE4E2",
        }}
      />
      {errorText != "" && (
        <StyledErrorTypography>{errorText}</StyledErrorTypography>
      )}
      <Button
        disabled={loadingBtn}
        onClick={handleSingUp}
        fullWidth
        variant="contained"
        sx={{ my: 2 }}
      >
        {" "}
        {loadingBtn ? <CircularProgress size={25} /> : "Sign Up"}
      </Button>
    </>
  );
};

export default SignUp;
